module.exports = __webpack_public_path__ + "static/media/img-boxfit-product-3.e6396fa6.png";